import O1HD from "../../../../engines/gameEngine";
import {loveStoryPeople, WithdrawChooseOption} from "./loveStoryConst";
import NormalGameManager from "../../manager/NormalGameManager";
import WithdrawNode from "./WithdrawNode";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;
/**
 * 添加提现 机会 次数
 */
@ccclass
export default class AddWithdrawCount extends cc.Component {

    @property({type:cc.Node,displayName:"中心动画节点"})
    centerNode:cc.Node = null;

    withdrawChooseOption : WithdrawChooseOption
    mParentScript : WithdrawNode;


    onLoad () {
        this.centerNode.scale = 0;
        cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    start () {

    }

    private mPeopleMap: loveStoryPeople;

    bindData( peopleMap: loveStoryPeople , withdrawChooseOption : WithdrawChooseOption , mParentScript : WithdrawNode ){
        this.mPeopleMap = peopleMap;
        this.withdrawChooseOption = withdrawChooseOption;
        this.mParentScript = mParentScript;
    }

    onBtnRefuse(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }


    onBtnAddCount(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.mParentScript.mPeopleMap.currDayWithdraw++;
            NormalGameManager._instance.loveStroyManager.writeData();
            this.mParentScript.mCompleteFun( this.withdrawChooseOption );
            this.mParentScript._close();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"添加提现次数");
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
